"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var frCA = {
  info: {
    culture: 'Canada',
    language: 'Canadian French',
    languageCultureCode: 'fr-CA'
  },
  translations: {
    '!': '!',
    save: 'économisez',
    extra: 'en plus',
    flavor: 'saveur',
    color: 'couleur',
    center: 'center',
    'What to Expect': 'Ce à quoi vous pouvez vous attendre',
    measurements: 'mesures',
    installation: 'installation',
    'Free In-Home Consultation': 'Consultation à domicile gratuite',
    'Cancel Changes': 'Annuler les changements',
    delivery: 'livraison',
    quantity: 'quantité',
    'Total Price': 'Total de la commande',
    'Free Delivery': 'Livraison gratuite',
    'Product Configuration Preview': 'Aperçu de la configuration du produit',
    'Enhanced Product Preview': 'Aperçu du produit amélioré',
    "new": 'nouveau',
    'Review Your Selections': 'Réviser vos sélections',
    'Check Availability': 'Vérifier la Disponibilité',
    brand: 'marque',
    'Guaranteed to Fit': 'Garantie de bonnes dimensions',
    'Customize and Buy': 'Personnaliser et acheter',
    "continue": 'continuer',
    'Ask a Question': 'Poser une Question',
    'Questions & Answers': 'Questions et réponses',
    'Learn More': 'En savoir plus',
    'Product Overview': 'Aperçu',
    specifications: 'spécifications',
    'Write a Review': 'Rédigez une Évaluation',
    'Customer Reviews': 'Avis des client',
    'Info & Guides': 'Informations et guides',
    inches: 'po',
    'in inches': 'en pouces',
    ok: 'ok',
    'Not Available': 'Non offert',
    extras: 'Suppléments',
    backordered: 'en rupture de stock',
    free: 'gratuite',
    by: 'par',
    By: 'Par',
    "for": 'pour',
    each: 'chaque',
    'pick-up': 'ramassage en magasin',
    'Pick-Up': 'Ramassage en magasin',
    'shipping icon': "icône d'expédition",
    'Shipping Icon': "Icône d'Expédition",
    'delivery icon': 'icône de livraison',
    'Delivery Icon': 'Icône de Livraison',
    'Tools Icon': 'Icône Outils',
    'tools icon': 'icône outils',
    'Shipping Alt Icon': "Icône alternative d'expédition",
    'Store Alt Icon': 'Icône alternative du magasin',
    'ship to home not available icon': 'icône de livraison à domicile non disponible',
    'Ship to Store Not Available Icon': 'Icône Expédier au magasin non disponible',
    'Guaranteed To Fit Badge': "Garanti pour s'adapter à l'insigne",
    shipping: 'expédition',
    'FREE Shipping': 'Livraison GRATUITE',
    'ship to store': 'expédier au magasin',
    'standard shipping': 'expédition standard',
    'Special Order SKU #': 'Commande Spéciale # SKU',
    'Order Sample': 'Commander un Échantillon',
    'No Sample': 'Aucun Échantillon',
    'Selected Color': 'Couleur Sélectionnée',
    'Zoom In': 'Agrandir',
    'Zoom Out': 'Dézoomer',
    minimize: 'minimiser',
    width: 'largeur',
    height: 'hauteur',
    eighths: 'huitièmes',
    whole: 'ensemble',
    'Drag Image': "Faire glisser l'image",
    'Made In': 'Fabriqué en',
    'Estimated Ship Date': "Date d'expédition estimative",
    'select a vendor': 'Sélectionnez un fournisseur',
    'Reload Page': 'Recharger la page',
    'you saved': 'vous avez enregistré',
    'Window Measurements': 'Mesures de fenêtre',
    'Enter Size': 'Entrer la taill',
    'add to cart': 'Ajouter au panier',
    'Add To Cart': 'Ajouter Au Panier',
    back: 'retour',
    'Ship to Home': 'Expédier à Domicile',
    model: 'modèle',
    'starting at': 'À partir de',
    'Internet #': "l'Internet #",
    'X Remove': 'X Retirer',
    download: 'télécharger',
    adds: 'ajoute'
  },
  translationsByKey: {
    templateChoiceConfig: "Ce choix n'est pas offert dans votre configuration actuelle",
    twoConsecutiveNotAllowed: '2 caractères spéciaux ". / ? - " consécutifs ou plus ne sont pas autorisés',
    specialNotAllowedExcept: 'Les caractères spéciaux (sauf " . / ? - ") ne sont pas autorisés et ont été supprimés',
    sizeNotAvailable: 'Non offert dans cette taille',
    tenCharLimit: 'Limite de 10 caractères.',
    of: {
      singular: 'de',
      plural: 'des'
    },
    forWidthByHeightIn: 'pour {width} po par {height} po',
    Pcp: {
      Configuration: {
        headerText: 'Configurez votre habillage de fenêtre',
        colorViewingOnly: "À des fins de visualisation des couleurs. Les options de montage, de cordon et d'inclinaison ne sont pas illustrées.",
        imagePreviewOnly: "Image à des fins de prévisualisation uniquement. Certaines options n'apparaîtront pas, mais seront réalisées en fonction de vos choix."
      },
      ErrorBoundary: {
        header: 'Un Chat a Ruiné Cette Page!',
        info: {
          line1: "On dirait que la page que vous cherchiez s'est un peu embrouillée",
          line2: 'Veuillez cliquer sur le bouton de rechargement ci-dessous',
          button: {
            ref: 'Reload Page'
          }
        }
      },
      MeasureSize: {
        tagWarning: 'Veuillez sélectionner un type de montage avant de saisir les mesures'
      },
      ProductInfo: {
        infoList: {
          shownIn: 'Montré dans',
          colorPlaceholder: 'Sélectionnez une Couleur à Prévisualiser',
          estShip: {
            ref: 'Estimated Ship Date'
          },
          basedOnSelections: 'En fonction de vos sélections'
        }
      },
      ProductInfoPrice: {
        suffix: 'Le prix comprend les options'
      },
      ProductInstallationCta: {
        toolTipText1: 'L’un de nos conseillers en aménagement Home Depot vous montrera une gamme d’options d’aménagement et d’échantillons, le tout dans le confort de votre maison.',
        toolTipText2: 'Un installateur Home Depot prendra les mesures, commandera vos habillages de fenêtre personnalisés et planifiera l’installation.',
        toolTipText3: 'L’installateur Home Depot installera ensuite vos nouveaux habillages de fenêtre personnalisés et effectuera un nettoyage complet une fois le travail terminé.',
        content: {
          header: 'Laissez-nous le faire pour vous',
          p: 'Obtenez une consultation d’aménagement à domicile gratuite, puis planifiez une installation.',
          button: 'Demander une consultation gratuite'
        }
      },
      SaveThisProduct: {
        button: 'Sauvegarder ce produit',
        error: 'Oups! On dirait que vous avez raté une étape'
      },
      SizeOptionGroup: {
        help: 'Si vous avez sélectionné **Montage intérieur**, saisissez la taille de votre fenêtre. Pour **Montage extérieur**, saisissez la taille du produit que vous souhaitez'
      },
      SubmitErrorModal: {
        title: 'Oups...',
        message: "Nous sommes désolés, mais il nous est impossible d'ajouter votre article au panier pour le moment",
        contactUs: 'Veuillez réessayer ou nous appeler au'
      },
      WindowNameTemplate: {
        maxLength: 'Le nom de fenêtre doit comprendre 10 caractères ou moins',
        required: 'Requis'
      }
    },
    Pip: {
      HowToGetItDynamic: {
        header: 'Comment l’obtenir',
        item1: {
          title: 'Ramassez en magasin',
          description: 'Non offert pour cet article',
          iconTitle: 'Shipping Icon'
        },
        item2: {
          title: {
            ref: 'Ship to Home'
          },
          description: 'Service d’expédition standard',
          iconTitle: 'Shipping Icon'
        },
        item3: {
          title: 'Livraison prévue',
          description: 'Non offert pour cet article',
          iconTitle: 'Delivery Icon'
        }
      },
      ProductGallery: {
        samplesCta: {
          header: 'Échantillons de couleur',
          description: 'Les 10 premiers échantillons sont gratuits et livrés le lendemain',
          hoverImageText: "Survolez l'image pour zoomer",
          productImagesText: 'Images du produit',
          button: {
            small: 'Commander',
            normal: 'Commander des échantillons de couleur'
          }
        }
      },
      ProductOptionsView: {
        sampleAlert: "Les commandes d'échantillons sont actuellement limitées et devraient être bientôt disponibles pour ce produit!",
        moreColorsButton: 'Voir plus de couleurs',
        appendAddSamples: ' et échantillons',
        // Work around for big text :(
        swatchCss: 'button { word-break: normal; white-space: normal; height: 95px; }'
      },
      ProductOverviewView: {
        exclusiveGuarantee: 'Vous vous souciez des mesures? Obtenez la tranquillité d’esprit avec la garantie de bonnes dimensions exclusive de Home Depot. Si votre parure de fenêtre ne convient pas, nous vous en enverrons une nouvelle sans frais. Nous nous occupons également des frais d’expédition!',
        guarantee: 'Vous vous souciez des mesures? Obtenez la tranquillité d’esprit avec la garantie de bonnes dimensions de Home Depot. Si votre parure de fenêtre ne convient pas, nous vous en enverrons une nouvelle sans frais. Nous nous occupons également des frais d’expédition!',
        sureFitList: {
          limit: 'Limite de 4 couvre-fenêtres par foyer.',
          refund: 'Aucun remboursement en espèces',
          exchange: 'Les échanges doivent être pour le même produit et la même couleur.',
          charges: 'Des frais supplémentaires peuvent s’appliquer s’il y a une différence de prix entre les anciennes et les nouvelles parures de fenêtres.',
          exchangeDays: 'Échange possible dans les {exchangeDays} jours suivant la livraison.',
          productReturn: 'Le produit doit être retourné en magasin pour remplacement'
        }
      },
      ProductPreviewView: {
        samples: {
          heading: 'Échantillons gratuits et livraison gratuite inclus',
          disclaimer: 'Si plus de 10 échantillons sont commandés, seuls les 10 premiers seront expédiés.',
          inCart: {
            large: 'échantillons gratuits dans le panier',
            normal: 'Échantillons Gratuits'
          },
          cartButton: {
            large: "Aller au panier d'échantillons",
            normal: "Panier d'échantillons"
          }
        }
      },
      ProductSpecifications: {
        infoAndGuidesAcrobat: {
          adobeNeeded: 'Home Depot fournira sur demande un document PDF en version accessible.',
          freeCopyDownload: "une copie gratuite sur le site Web d'Adobe.",
          freeCopy: 'Veuillez nous contacter au 1-800-628-0525.'
        }
      },
      ProductSummary: {
        dropdownLabel: 'produit',
        widthEighths: 'Largeur du {dropdownLabel} (huitièmes)',
        widthWholes: 'Largeur du {dropdownLabel}  (po)',
        heightEighths: 'hauteur du {dropdownLabel} (huitièmes)',
        heightWholes: 'hauteur du {dropdownLabel} (po)',
        CTANoShipping: {
          description: "Nous ne sommes pas en mesure d'expédier cet article aux maisons et magasins situés dans : AK, GU, HI, PR, VI"
        },
        Highlights: {
          shipping: {
            description: 'Livraison Gratuite'
          },
          productionTime: {
            description: 'Normalement fabriqué en {days} jours ouvrables'
          },
          expertHelp: {
            description: "Appelez le {contactNumber} pour obtenir l'aide gratuite d'un expert"
          }
        },
        PriceMayVary: {
          message: 'Les prix et les quantités peuvent varier d’un magasin à un autre, et entre la vente en ligne et en magasin.',
          detailsLink: 'Cliquez ici pour plus de détails.'
        }
      },
      ThdPipView: {
        emailUs: {
          text: 'Envoyez-nous un email',
          size: 200
        },
        mandiHeaderLink: "Vous utilisez notre service d'habillage de fenêtre personnalisé. Cliquez ici pour revenir au site Web normal."
      }
    },
    ErrorBoundary: {
      header: 'Quelque chose n’a pas fonctionné.'
    },
    SamplesCart: {
      yourSamplesCart: 'Panier d’échantillons',
      outOfItems: 'de',
      banner: {
        freeMessageOrderUpTo: "Commandez jusqu'à 10 échantillons gratuits,",
        freeMessageOrderInfo: 'Si plus de 10 échantillons sont commandés, seuls les 10 premiers seront expédiés.',
        continueShopping: 'Continuer de magasiner',
        title: 'Livraison gratuite',
        thankYouMessage: 'Votre commande a bien été reçue. Numéro de commande',
        copyOrderNumber: 'Une copie de cette commande a été envoyée à votre adresse courriel.'
      },
      emptyCart: {
        messageTitle: 'Commencez à ajouter des échantillons!',
        freeMessage: 'Livraison gratuite!',
        messageParagraph: 'Si plus de 10 échantillons sont commandés, seuls les 10 premiers seront expédiés.',
        orderSamplesButton: 'Commander des échantillons'
      },
      choiceName: 'Couleur',
      modal: {
        cancelButton: 'Annuler',
        continueButton: 'Confirmer',
        deleteConfirmation: 'Voulez-vous vraiment supprimer cet article du panier?',
        errorRemovingItem: "Erreur lors de la suppression de l'élément, veuillez réessayer plus tard.",
        removeButton: 'Retirer',
        removeTitle: "Retirer l'objet",
        "continue": 'Confirmer',
        sample: 'Échantillon',
        samples: 'Échantillons',
        sampleLimitMsg: 'Vous avez dépassé la limite de 10 échantillons.',
        sampleLimitTitle: "Limite d'échantillon atteinte",
        pleaseRemove: "S'il vous plaît retirer",
        pleaseRemoveEnd: 'de votre panier pour finaliser votre commande.'
      },
      removeItem: 'Supprimer',
      shipToHome: 'Livraison',
      shippedIn: 'Expédié en',
      deliveryTimeDay: 'Jour ouvrable',
      deliveryTimeDays: 'Jour ouvrables',
      deliveryInfo: {
        title: 'Renseignements sur la livraison',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        phone: 'Téléphone',
        email: 'Adresse courriel',
        address: 'Adresse',
        addressLine1: 'Entrez votre adresse...',
        addressLine2: "Nº d'appartement, Nº de suite (Facultatif)",
        city: 'Ville',
        province: 'Province',
        postalCode: 'Code postal',
        submit: 'Soumettre',
        select: 'Sélectionner'
      },
      errorMessages: {
        firstName: 'Le prénom est requis',
        lastName: 'Le nom de famille est requis',
        phone: 'Le numéro de téléphone est requis',
        phone2: 'Numéro de téléphone invalide',
        email: "L'e-mail est requis",
        address: "L'adresse est obligatoire",
        city: 'La ville est obligatoire',
        province: 'La province est requise',
        postalCode: 'Le code postal est requis',
        oops: 'Oups!',
        errorDetails: "Nous sommes désolés mais la page que vous avez demandée n'a pas été trouvée.",
        errorCode: "Code d'erreur : 404"
      },
      samplesAlert: {
        exceededMessage: 'Vous avez atteint la limite d’échantillons gratuits.',
        pleaseMessage: 'Seuls les 10 premiers échantillons seront expédiés.',
        samples: 'échantillon',
        sample: 'échantillons',
        pleaseMessageEnd: 'seront expédiés.'
      },
      orderConfirmation: {
        sampleItem: 'Échantillon(s)',
        shippingTitleContact: 'Confirmation de la livraison'
      }
    }
  }
};
var _default = frCA;
exports["default"] = _default;